export default __webpack_public_path__ + "static/media/SmartphoneOrange.4f6d73c5.svg";